import { Controller } from "@hotwired/stimulus";

// Warns when the use case's auto-trigger SOP won't fire as expected. Sandbox conversations key off
// the SOP's draft enabled flag and live conversations off the live flag, so the failure mode differs:
//   - neither enabled  -> won't trigger in sandbox or live          (warningNone)
//   - draft only       -> triggers in sandbox, not live (publish)   (warningDraftOnly)
//   - live only        -> triggers live, not in sandbox (enable)    (warningLiveOnly)
// The initial state is rendered server-side; we only react to user changes here.
export default class extends Controller {
  static targets = ["triggerType", "sopSelect", "warningNone", "warningDraftOnly", "warningLiveOnly"];

  refresh() {
    const state = this.sopState();
    this.warningNoneTarget.classList.toggle("hidden", state !== "none");
    this.warningDraftOnlyTarget.classList.toggle("hidden", state !== "draft-only");
    this.warningLiveOnlyTarget.classList.toggle("hidden", state !== "live-only");
  }

  sopState() {
    if (this.triggerTypeTarget.value !== "SOP") return "ok";

    const selected = this.sopSelectTarget.selectedOptions[0];
    if (!selected || !selected.value) return "ok";

    const draft = selected.getAttribute("data-draft-enabled") === "true";
    const live = selected.getAttribute("data-live-enabled") === "true";

    if (draft && live) return "ok";
    if (draft) return "draft-only";
    if (live) return "live-only";
    return "none";
  }
}
